import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AccelaTextValidators {

  private readonly EMAIL_REGEXP =
  // eslint-disable-next-line max-len
  /^(?=.{1,254}$)(?=.{1,64}@)[\w+_-]+(?:\.[\w+_-]+)*@[\w+_-](?:[\w+_-\s]{0,61}\w)?(?:\.[\w](?:[\w]{0,61}\w)?)+$/;


  emailValidate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value;

      if (!value || value.length === 0) {
        return null;  // don't validate empty values to allow optional controls
      }
      return this.EMAIL_REGEXP.test(value) ? null : { email: true };
    };
  }


}

